const formatDescriptorOriginField = (prefix, index, key = 'text') =>
  `${prefix}:${key}:${index}`

export default formatDescriptorOriginField
